// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"434":"a54d3fb6","930":"3eda2ff4"}[chunkId] + ".chunk.css";
};